import { render, staticRenderFns, recyclableRender, components } from "./clerk.vue?vue&type=template&id=f1e0b8c6&"
var renderjs
import script from "./clerk.vue?vue&type=script&lang=js&"
export * from "./clerk.vue?vue&type=script&lang=js&"
import style0 from "./clerk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages2/delivery/clerk.vue"
export default component.exports